import { useEffect } from 'react';
import { initAmplitude } from 'shared/utils/amplitude/amplitude';
import { useIsMapsRegionalMimicClient, useMapsAgentMimicClient, useUser } from 'store/features/auth';

export const useInitAnalytics = () => {
  const user = useUser();
  const isMapsRegionalMimicClient = useIsMapsRegionalMimicClient();
  const isMapsAgentMimicClient = useMapsAgentMimicClient();

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      return;
    }
    if (user) {
      if (isMapsRegionalMimicClient || isMapsAgentMimicClient) {
        initAmplitude({ userId: `${user.clientCode}_manager` });
        return;
      }
      initAmplitude({ userId: user.clientCode });
    }
  }, [isMapsAgentMimicClient, isMapsRegionalMimicClient, user]);
};
